import moment from "moment";
import "moment/locale/ko";

export default function(date: Date): string {
  return moment(date, "YYYY-MM-DD HH:mm").fromNow();
}
